/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建公告
 */
'use strict';
angular.module("newNoticeRouterModule", ['newNoticeRouter']).
controller('newNoticeCtrl', ['$scope', '$element', '$stateParams', '$q', '$compile', 'httpService', 'modalDialog', 'ueditorService', '$validation', 'localStorageService', '$timeout', function($scope, $element, $stateParams, $q, $compile, httpService, modalDialog, ueditorService, $validation, localStorageService, $timeout) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions: [{
                name: '全体',
                value: 0
            }, {
                name: 'ugc用户',
                value: 1
            }, {
                name: 'pgc用户',
                value: 2
            }],
            noticeId: $stateParams.docId,
        }
        $scope.data = {

        };
        $scope.list = {
            id: 0,
            articleTitle: "",
            articleChannel: 0,
            articleHtmlCon: ''
        };
        $scope.status.selectedChannel = angular.copy($scope.status.channelsOptions[0]);
    };

    function initData() {
    	$("html").css('backgroundColor', '#F5F7FA');
        getAuthority().then(function() {
            initList().then(function() {
                loadUeditor();
            });
        })
    };
    /**
     * [getAuthority description] 获取权限
     * @return {[type]} [description]
     */
    function getAuthority() {
        var deffer = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getCurrUserAuthInfo.do", "", "post").
        then(function(data) {
            $scope.data.authority = data.data;
            $scope.$root.authority = $scope.data.authority;
            deffer.resolve();
        });
        return deffer.promise;
    };
    /**
     * [initList description] 初始化公告数据
     * @return {[type]} [description]
     */
    function initList() {
        var deffer = $q.defer();
        if ($stateParams.docId != 0) {
            getDraftInfo().then(function(result) {
                $scope.list.id = result.id;
                $scope.list.articleTitle = result.noticeTitle;
                $scope.list.articleHtmlCon = result.noticeContent;
                $scope.list.articleChannel = result.noticeChannel;
                $scope.status.selectedChannel = angular.copy($scope.status.channelsOptions[result.noticeChannel]);
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }
    /**
     * [getDraftInfo description] 查询稿件信息
     * @return {[type]} [description]
     */
    function getDraftInfo() {
        var deffer = $q.defer();
        var params = {
            id: $stateParams.docId
        };
        httpService.http("/mcnadmin/admin/notice/findById.do", params, "get").then(function(result) {
            deffer.resolve(result.data);
        });
        return deffer.promise;
    }
    /**
     * [loadUeditor description] 加载编辑器
     * @return {[type]} [description]
     */
    function loadUeditor() {
        var $ueditor = $("<ueditor></ueditor>");
        var $ueditorLocation = $element.find("ueditorLocation");
        LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function() {
            $ueditor.attr({
                list: "list",
                "has-content": "status.hasContent",
                versionid: $scope.list.id,
                infullscreen: "status.infullscreen",
                type: "{{'newNotice'}}"
            });
            $ueditor = $compile($ueditor)($scope);
            $ueditorLocation.append($ueditor);
        });

    }
    /**
     * [saveNotice description] 保存公告
     * @return {[type]} [description]
     */
    function saveNotice(ispub) {
        var defer = $q.defer();
        var d = $scope.list;
        var params = {
            id: d.id,
            noticeTitle: d.articleTitle,
            noticeContent: d.articleHtmlCon,
            noticeChannel: $scope.status.selectedChannel.value,
            bPub: ispub
        };
        httpService.http("/mcnadmin/admin/notice/addNotice.do", params, "post").then(function(result) {
            defer.resolve(result);
        });
        return defer.promise;
    }

    /**
     * [saveContent description] 保存正文
     * @return {[type]} [description]
     */
    function saveContent() {
        var deffer = $q.defer();
        ueditorService.saveContent($scope.list);
        if ($scope.list.articleHtmlCon === "") {
            $timeout(function() {
                //表单校验手动触发
                $scope.editPageForm.content.$error.content = true;
                $scope.editPageForm.content.$valid = false;
                $scope.editPageForm.content.$invalid = true;
                $scope.editPageForm.$error.content = [$scope.editPageForm.content];
                $scope.editPageForm.$valid = false;
                $scope.editPageForm.$invalid = true;
                deffer.resolve();
            });
        } else {
            deffer.resolve();
        }
        return deffer.promise;
    }

    /**
     * [submission description] 保存或发布公告
     * @return {[type]} [description]
     */
    $scope.submission = function(ispub) {
        saveContent().then(function() {
            return validator();
        }).then(function() {
            return saveNotice(ispub);
        }).then(function(data) {
            if (data.success) {
                var txt = "";
                txt = ispub === 0 ? "保存成功" : "发布成功";
                var newId = data.id;
                reFreshListPage();
                ueditorService.saveToLocal(newId);
                modalDialog.alertType('', txt, 'success', false, function() {
                    window.close();
                });
            }
        });
    };

    /**
     * [validator description] 表单校验
     * @return {[type]} [description]
     */
    function validator() {
        var deffer = $q.defer();
        $validation.validate($scope.editPageForm).success(function() {
            deffer.resolve();
        }).error(function(result) {
            angular.invalidPosition($scope.editPageForm, $element);
        });
        return deffer.promise;
    }

    /**
     * [reFreshList description] 刷新列表页
     * @return {[type]} [description]
     */
    function reFreshListPage() {
        localStorageService.set("refresh", Math.random());
    }
}]);